export enum SurveyCSATType {
  EDITOR = 'EDITOR',
  // COPILOT = 'COPILOT',
  // DESIGN_GEN = 'DESIGN_GEN',
  // Previously used survey types:
  // TEMPLATE = 'TEMPLATE',
  // ELEMENT = 'ELEMENT',
  // MOCKUP = 'MOCKUP',
  // TYPEFACE = 'TYPEFACE',
}

export interface SurveyCSATStatus {
  eligibility: {
    editor: boolean;
    template: boolean;
    element: boolean;
    mockup: boolean;
    typeface: boolean;
    copilot: boolean;
    account: boolean;
    design_gen: boolean;
  };
}
